import { civilDateKey, isWeekend } from './day-helpers.js';
import type { Holiday, ObservedHoliday, SkippedDate } from './types.js';

/**
 * Shared between both US Federal handlers: we only load federal holidays, but
 * FRCP 6(a)(6)(C) folds in state-declared legal holidays for forward-counted
 * periods, and we have no way to infer the forum state.
 */
export const US_STATE_HOLIDAY_WARNING =
  'Only federal legal holidays are counted. State-declared legal holidays can also extend forward-counted deadlines under FRCP 6(a)(6)(C) and are not included here, so check the forum state.';

export function buildObservedHolidays(
  holidayMap: Map<string, Holiday>,
  windowStart: Date,
  windowEnd: Date,
): ObservedHoliday[] {
  const result: ObservedHoliday[] = [];
  for (const h of holidayMap.values()) {
    const t = h.date.getTime();
    if (t >= windowStart.getTime() && t <= windowEnd.getTime()) {
      result.push({ date: h.date, name: h.name });
    }
  }
  result.sort((a, b) => a.date.getTime() - b.date.getTime());
  return result;
}

export function classifyDay(
  date: Date,
  holidayMap: Map<string, Holiday>,
): { isCounting: boolean; skip?: SkippedDate } {
  if (isWeekend(date)) {
    return { isCounting: false, skip: { date, reason: 'weekend' } };
  }
  const holiday = holidayMap.get(civilDateKey(date));
  if (holiday !== undefined) {
    return { isCounting: false, skip: { date, reason: 'public-holiday', name: holiday.name } };
  }
  return { isCounting: true };
}
